<app-header page='create'>Campaign Naming Builder</app-header>

<div class="create-campaign content container">
  <app-campaign-form mode="{{formMode.CREATE}}"></app-campaign-form>
</div>